import { render, staticRenderFns } from "./ApplicantMessageRegister.vue?vue&type=template&id=f788bcfe"
import script from "./ApplicantMessageRegister.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports